/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/sectors/DocumentList/DocumentList.config.js
 * File: DocumentList.config.js
 * Created Date: Wednesday, January 23rd 2019, 11:11:44 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Jan 23 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { FuseLoadable } from 'modules/@fuse'
import { authRoles } from 'modules/auth'

export const DocumentListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.staff,
  routes: [{
    path: '/:projectId/documents',
    component: FuseLoadable({
      loader: () => import('./DocumentList')
    })
  }]
}
